<template>
  <div class="element-menu">
    <button class="btn btn-default" type="button" @click.prevent="toggleMenu">
      <div>
        {{
          !changedType && !selectedType
            ? "Non précisé"
            : changedType
            ? changedType.type
            : selectedType
        }}
      </div>
      <font-awesome-icon
        :icon="isShow ? ['fas', 'caret-up'] : ['fas', 'caret-down']"
      />
    </button>
    <ul ref="menuselectwrapper" class="menu-select-wrapper" v-show="isShow">
      <li
        v-for="(item, index) in menuItems"
        :class="{ 'dropdown-submenu': item.children }"
        :key="index"
      >
        <div>
          <div v-if="!item.children" class="menu-item-wrap">
            <a tabindex="-1" href="#" @click.prevent="selectedMenu(item)"
              >{{ item.type }}
            </a>
            <span
              class="edit-icon"
              v-if="item.editable"
              @click="handleEditFormat(item.id, item.type)"
              ><font-awesome-icon :icon="['fas', 'edit']"
            /></span>
          </div>

          <a v-else class="test" tabindex="-1" href="#"
            >{{ item.type }}
            <font-awesome-icon
              :icon="['fas', 'angle-right']"
              v-if="item.children"
            />
          </a>
        </div>

        <ul v-if="item.children">
          <li v-for="(child, indexChild) in item.children" :key="indexChild">
            <div class="menu-item-wrap">
              <a tabindex="-1" href="#" @click.prevent="selectedMenu(child)">{{
                child.type
              }}</a>

              <span
                class="edit-icon"
                v-if="child.editable"
                @click="handleEditFormat(child.id, child.type)"
                ><font-awesome-icon :icon="['fas', 'edit']"
              /></span>
              <span v-if="child.editable" @click="handleDeleteFormat(child.id)"
                ><font-awesome-icon :icon="['fas', 'times']"
              /></span>
            </div>
          </li>
        </ul>
      </li>
      <li class="ajoutformat">
        <a @click.prevent="handleAjoutFormatPerso" href="#"
          >Ajouter un nouveau format</a
        >
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    menuItems: Array,
    selectedType: String,
    colIndex: Number
  },
  data () {
    return {
      isShow: false,
      changedType: null
    }
  },
  methods: {
    toggleMenu () {
      this.isShow = !this.isShow
      this.$emit('togglemenu', this.isShow, this.colIndex)
    },
    selectedMenu (type) {
      this.changedType = type
      this.isShow = false
      this.$emit('selectType', this.colIndex, type)
    },
    handleAjoutFormatPerso () {
      this.$emit('addFormat')
    },
    handleDeleteFormat (idType) {
      this.$emit('deleteFormat', idType)
    },
    handleEditFormat (idType, type) {
      this.$emit('editFormat', idType, type)
    }
  }
}
</script>
<style lang="scss">
.element-menu {
  border-right: 1px solid #fff;
  left: 1px;
  button {
    color: #fff !important;
    font-size: 12px;
    font-weight: 400;
    font-family: "Open Sans";
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 16px;
    background-color: #2b3085;
    line-height: 16px;
    padding: 0 5px;
    text-align: center;
    font-size: 8px;
    div {
      padding-right: 5px;
      line-height: 1;
    }
  }
}
.element-menu {
  position: relative;
  & > ul {
    margin-top: 50px;
    &:before {
      display: none;
      content: "";
      width: 0;
      height: 0;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 7px solid #fff;
      position: absolute;
      top: -7px;
      left: 15px;
    }
  }
  .menu-select-wrapper,
  ul {
    border: none;
    box-shadow: 0 9px 15px 0 rgba(0, 0, 0, 1);
    margin-top: 0px;
    list-style: none;
    padding: 0px 0px;
    position: absolute;
    background-color: #fff;
    border-radius: 0px;
    z-index: 100;
    li {
      &:hover {
        background-color: #d2d3e5;
      }
    }
    a {
      color: #2b3085;
      font-size: 12px;
      line-height: 23px;
      font-family: "Noto Sans", sans-serif;
      height: 23px;
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 15px;
      padding-right: 15px;
      display: block;
      text-decoration: none;
      white-space: nowrap;
    }
    .menu-item-wrap {
      display: flex;
      justify-content: space-between;
      padding-right: 10px;
      color: rgba(256, 0, 0, 0.9);
      align-items: center;
      span {
        position: relative;
        z-index: 100;
        cursor: pointer;
        font-size: 11px;
        &.edit-icon {
          color: #2b3085;
        }
      }
    }
    li {
      position: relative;
      &.ajoutformat {
        a {
          color: #2b3085;
        }
      }
      ul {
        position: absolute;
        left: 100%;
        background-color: #fff;
        padding-left: 0px;
        list-style: none;
        // top: 0;
        bottom: 0;
        padding-right: 0px;
        padding-top: 0;
      }
    }
    .dropdown-submenu {
      a {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      ul {
        left: 100%;
        box-shadow: 5px 0px 15px 0 rgba(0, 0, 0, 0.1);
        display: none;
      }
      &:hover {
        ul {
          display: block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tableau/typeDonne.vue